import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";

import { domain } from "../../Urls/Services/Api_urls";

import "./Subcarouselcomp.css";
const Subcarouselcomp = () => {
  const [data, setData] = useState([]);
  const [carouselImages, setCarouselImages] = useState([]);
  let nextId = 0;

  useEffect(() => {
   /**
    * The function `getData` fetches data from a specified domain and sets the retrieved data and
    * carousel images in the state.
    */
    const getData = () => {
      fetch(domain + "/images/carousel/", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((data) => data.json())
        .then((data) => {
          setData(data);

          const newCarouselImages = data.map((item) => {
            const carousel = window.innerWidth < 540 ? item.carousel_responsive : item.carousel;
            return {
              id: nextId++,
              carousel: domain + carousel,
            };
          });
          setCarouselImages(newCarouselImages);
        });
    };
    getData();
  }, []);
 
  return (
    <>
      <Carousel fade={true} pause={false}>
        
        {carouselImages.map((image) => (
          <Carousel.Item key={image.id} interval={5000}>
            <img
              className="responsive1 d-block w-100 z-0"
              src={image.carousel}
              alt="First slide"
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  );
};

// Components used:
// - Carousel from react-bootstrap.

export default Subcarouselcomp;

// ## Summary
// This code defines a React functional component called `Subcarouselcomp` that fetches data from a specified domain and displays a carousel of images using the React Bootstrap library.

// ## Example Usage
// ```javascript
// import Subcarouselcomp from "./Subcarouselcomp";

// const App = () => {
//   return (
//     <div>
//       <h1>Subcarousel Component</h1>
//       <Subcarouselcomp />
//     </div>
//   );
// };

// export default App;
// ```

// ## Code Analysis
// ### Inputs
// - None
// ___
// ### Flow
// 1. The component initializes two state variables, `data` and `carouselImages`, using the `useState` hook.
// 2. The component defines a function named `getData` that fetches data from the specified domain using the `fetch` API.
// 3. The fetched data is converted to JSON using the `json` method and stored in the `data` state variable.
// 4. The `data` state variable is mapped to create an array of carousel images, where each image object contains an `id` and the URL of the image.
// 5. The array of carousel images is stored in the `carouselImages` state variable.
// 6. The `getData` function is called once when the component mounts, using the `useEffect` hook with an empty dependency array.
// 7. The component renders a `Carousel` component from the React Bootstrap library.
// 8. The `carouselImages` state variable is mapped to create a `Carousel.Item` component for each image.
// 9. Each `Carousel.Item` component contains an `img` element with the URL of the image.
// 10. The `Carousel` component displays the carousel of images.
// ___
// ### Outputs
// - The `Subcarouselcomp` component renders a carousel of images fetched from the specified domain.
// ___
